module.exports = __webpack_public_path__ + "static/tasha1-c195a7298d35bdc4bb638b6abc192b15.jpg";